import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({
    title = "Savana Ashlea | Art, Photography & Wellness",
    description = "Creating beautiful moments through art, photography, and wellness. Explore stunning photography, meaningful artwork, and transformative yoga experiences with Savana Ashlea.",
    image = "/og-image.jpg",
    url = "https://savanashlea.com/",
    type = "website"
}) => {
    const fullImageUrl = image.startsWith('http') ? image : `https://savanashlea.com${image}`;

    return (
        <Helmet>
            {/* Primary Meta Tags */}
            <title>{title}</title>
            <meta name="title" content={title} />
            <meta name="description" content={description} />

            {/* Open Graph / Facebook */}
            <meta property="og:type" content={type} />
            <meta property="og:url" content={url} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={fullImageUrl} />
            <meta property="og:image:width" content="1200" />
            <meta property="og:image:height" content="630" />

            {/* Twitter */}
            <meta property="twitter:card" content="summary_large_image" />
            <meta property="twitter:url" content={url} />
            <meta property="twitter:title" content={title} />
            <meta property="twitter:description" content={description} />
            <meta property="twitter:image" content={fullImageUrl} />

            {/* Canonical URL */}
            <link rel="canonical" href={url} />
        </Helmet>
    );
};

export default SEO;